import { render, staticRenderFns } from "./FreeePostDialog.vue?vue&type=template&id=f5c62cf2&"
import script from "./FreeePostDialog.vue?vue&type=script&lang=js&"
export * from "./FreeePostDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports